import { Trans } from '@lingui/macro'
import { Box, Button, Typography } from '@mui/material'
import { getMaintenanceData, MaintenanceResult } from 'app/backend/selesforce-custom-queries/Maintenance'
import CustomizableLogo from 'app/views/common-components/CustomizableLogo'
import Loading from 'egret/components/EgretLoadable/Loading'
import moment from 'moment'
import React, { useEffect } from 'react'

const WEBSITE_URL = 'https://centre.support/'

export const MaintenanceGuard: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [maintenance, setMaintenance] = React.useState<MaintenanceResult | null>(null)
  const [checked, setChecked] = React.useState(false)

  useEffect(() => {
    void getMaintenanceData().then(result => {
      setMaintenance(result)
      setChecked(true)
    }, reject => {
      setChecked(true)
    })
  }, [])

  const isMaintenancePeriod = checked && Boolean(maintenance?.maintenanceMode) && maintenance?.startAt != null && moment().isBetween(maintenance?.startAt, maintenance?.endAt)

  if (isMaintenancePeriod) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '34px',
            backgroundImage: 'url("/assets/images/chtc-half-logo-small-spaces.png")',
            backgroundSize: 'auto',
            backgroundPosition: 'center',
            backgroundRepeat: 'repeat-x'
          }}
        />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: '45px'
          }}
        >
          <Box
            component='img'
            src='/assets/images/centre-logo.svg'
            alt='My Centre'
            sx={{
              height: '48px',
              mr: 1
            }}
          />
          <Typography
            variant='h5'
            sx={{
              fontWeight: 600,
              color: '#1a3a52',
              fontSize: '28px',
              lineHeight: '32px'
            }}
          >
            <Trans>MY_CENTER</Trans>
          </Typography>
        </Box>

        <Box
          sx={{
            backgroundColor: 'white',
            padding: '48px',
            pt: '40px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            zIndex: 1,
            position: 'relative'
          }}
        >
          <CustomizableLogo
            color='#9AC765'
            opacity={0.3}
            sx={{ position: 'absolute', top: '-47px', left: '-194px', width: '194px', height: 'auto' }}
          />
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              color: '#1a3a52',
              mb: '32px',
              fontSize: '24px',
              lineHeight: '28px'
            }}
          >
            <Trans>SCHEDULED_MAINTENANCE_LABEL</Trans>
          </Typography>

          <Typography
            variant='body1'
            sx={{
              lineHeight: '20px',
              fontSize: '14px',
              mb: '24px',
              textAlign: 'left'
            }}
          >
            {maintenance?.messageResolved}
          </Typography>

          <a href={WEBSITE_URL}>
            <Button
              variant='contained'
              fullWidth
            >
              <Trans>GO_TO_WEBSITE_BTN</Trans>
            </Button>
          </a>
        </Box>
      </Box>
    )
  }

  if (!checked) {
    return <Loading />
  }

  return <>{children}</>
}
